export const paths = {
  any: '*',
  dashboard: '/dashboard',
  organizations: {
    root: '/organizations',
    details: '/organizations/:organizationId',
  },
  projects: {
    root: '/projects',
    new: '/projects/new',
    details: {
      root: '/projects/:projectId',
      tab: '/projects/:projectId/:tab',
    },
    children: {
      details: ':projectId',
    },
  },
  vendors: {
    root: '/vendors',
    details: '/vendors/:vendorId',
  },
  login: '/login',
} as const;
